import { Component, Input } from '@angular/core';
import { productDisplayName } from '@kservice';
import { Product } from '@ktypes/enums';
import { format } from 'date-fns';

@Component({
  selector: 'kp-copyright',
  templateUrl: './copyright.component.html',
  styleUrls: ['./copyright.component.scss'],
})
export class CopyrightComponent {
  @Input() includeProMedica = false;
  @Input() includeKumanuTrademark = false;
  @Input() includePromedicaJointTrademark = false;
  @Input() product: Product;

  productDisplayName = productDisplayName;

  year: string = format(new Date(), 'yyyy');
}
